import {Component, Input, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {FooterClientFallbackEventInterface, FooterRenderedEventInterface} from '@wellfit/wf-plans-services';
import {EventsManager} from 'src/app/events/events.manager';
import {FeatureFlagService, Features} from 'src/app/services/feature.service';
import {AppInsightsService} from 'src/app/services/app-insights.service';
import {PlanViewTypeEnum} from '../../enums/plan-view-type.enum';
import {isOfferedForSelection} from '../../utils/coverage-level.util';
import {MainPageDetailModel} from '../../models/plans.model';

@Component({
  selector: 'app-plan-disclosure',
  templateUrl: './plan-disclosure.component.html',
  styleUrls: ['./plan-disclosure.component.scss'],
  standalone: false
})
export class PlanDisclosureComponent {
  @Input() public officeData?: MainPageDetailModel;
  @Input() public templateId?: string;
  @Input() public type?: PlanViewTypeEnum;
  @Input() public coverageLevelId?: string;

  public readonly eventsManager: EventsManager = inject(EventsManager);
  private readonly _featureFlagService: FeatureFlagService = inject(FeatureFlagService);
  private readonly _appInsights: AppInsightsService = inject(AppInsightsService);

  public dynamicFooterEnabled$: Observable<boolean> = this._featureFlagService.isFeatureEnabled(Features.DynamicFooter);

  public get isWellfitAdmin(): boolean {
    return this.eventsManager.legalLanguage?.adminBy === 'wellfit';
  }

  public get isOfficeReady(): boolean {
    return !!this.templateId || !!this.officeData?.practiceId;
  }

  public get effectiveTemplateId(): string | undefined {
    return this.templateId ?? this.officeData?.benefitPlanTemplates?.[0]?.benefitPlanTemplateId;
  }

  public get effectiveType(): PlanViewTypeEnum | undefined {
    return this.type ?? (this.effectiveTemplateId ? PlanViewTypeEnum.Detail : undefined);
  }

  public get effectiveCoverageLevelId(): string | undefined {
    return this.coverageLevelId ?? this.officeData?.benefitPlanTemplates?.[0]?.coverageLevels?.find(isOfferedForSelection)?.benefitPlanCoverageLevelId ?? undefined;
  }

  public onFooterRendered(event: FooterRenderedEventInterface): void {
    this._appInsights.trackEvent('footer.render', {
      versionId: event.versionId,
      usedFallback: event.usedFallback,
      missingTokens: event.missingTokens.join(','),
      templateId: event.templateId ?? null,
      type: event.type ?? null
    });
  }

  public onFooterClientFallback(event: FooterClientFallbackEventInterface): void {
    this._appInsights.trackEvent('footer.client-fallback', {
      portalCode: event.portalCode ?? null,
      reason: event.reason,
      errorSummary: event.errorSummary
    });
  }
}
